import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ebc7651")

_pushScopeId("data-v-5ebc7651")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回列表")
const _hoisted_2 = { class: "enterpriseInformation" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "企业信息", -1)
const _hoisted_4 = { style: {"width":"220px","display":"inline-block"} }
const _hoisted_5 = { class: "businessLicense" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, [
  /*#__PURE__*/_createVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode("营业执照")
], -1)
const _hoisted_7 = { class: "businessPhone" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "ant-upload-text" }, "营业执照", -1)
const _hoisted_10 = { class: "shippingContact" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h3", null, "发货联系人信息", -1)
const _hoisted_12 = { style: {"width":"220px","display":"inline-block"} }
const _hoisted_13 = { class: "aOwner" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 返回 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_a_button, {
      onClick: _ctx.backList,
      style: {"margin-bottom":"10px"}
    }, {
      default: _withId(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_form, {
      ref: "formRef",
      labelCol: { style: 'width: 250px' },
      model: _ctx.formState,
      rules: _ctx.rules
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_row, { class: "enterRow" }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "唯一标识:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_4, _toDisplayString(_ctx.formState.fbfuuid), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "企业纳税人识别号:",
                class: "aManagementInput",
                name: "nsrsbh"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.nsrsbh,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formState.nsrsbh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入企业纳税人识别号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "企业名称:",
                class: "aManagementInput",
                name: "nsrmc"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.nsrmc,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formState.nsrmc = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入企业名称"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "法定代表人:",
                class: "aManagementInput",
                name: "fddbr"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    style: {"width":"220px"},
                    value: _ctx.formState.fddbr,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formState.fddbr = $event)),
                    placeholder: "请输入法定代表人"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "企业手机号码:",
                class: "aManage",
                name: "qyyddh"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.qyyddh,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formState.qyyddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入企业手机号码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "主管税务机关:",
                class: "aManage",
                name: "zgswjg"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.zgswjg,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formState.zgswjg = $event)),
                    placeholder: "请输入主管税务机关",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange1,
                    onSearch: _ctx.handleSearchCertificate
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taxOffice, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.name
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "企业类型:",
                class: "aManagementInput",
                name: "nsrlx"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    placeholder: "请输入企业类型",
                    showSearch: "",
                    style: {"width":"220px"},
                    value: _ctx.formState.nsrlx,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formState.nsrlx = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.verifyStatedOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.id,
                          value: item.id
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "注册资本(万):",
                class: "aManage",
                name: "zczb"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    style: {"width":"220px"},
                    value: _ctx.formState.zczb,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formState.zczb = $event)),
                    placeholder: "请输入注册资本"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "成立日期:",
                class: "aManage",
                name: "slrq"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withId(() => [
                      _createVNode(_component_a_date_picker, {
                        value: _ctx.formState.slrq,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formState.slrq = $event)),
                        style: {"width":"220px"},
                        format: "YYYY-MM-DD HH:mm:ss",
                        "show-time": "",
                        placeholder: "请输入时间",
                        onChange: _ctx.onChange1,
                        onOk: _ctx.onOk
                      }, null, 8, ["value", "onChange", "onOk"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "公司地址:",
                class: "aManagementInput",
                name: "gsdz"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.gsdz,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formState.gsdz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入公司地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "详细地址:",
                class: "aManage",
                name: "xxdz"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.xxdz,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formState.xxdz = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入详细地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "所属地区:",
                class: "aManage",
                name: "ssdq"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    "show-search": "",
                    value: _ctx.formState.ssdqName,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formState.ssdqName = $event)),
                    placeholder: "请输入所属地区",
                    style: {"width":"220px"},
                    "default-active-first-option": false,
                    "show-arrow": false,
                    "filter-option": false,
                    "not-found-content": null,
                    onChange: _ctx.handleChange,
                    onSearch: _ctx.handleSearchEachDistrict
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eachDistrict, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: index,
                          value: item.code
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.name+"("+item.code+")"), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange", "onSearch"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "经营范围:",
                class: "aManagementInput",
                name: "jyfw"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.jyfw,
                    "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formState.jyfw = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入经营范围"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "注册时间:",
                class: "aManage",
                name: "ptzcsj"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withId(() => [
                      _createVNode(_component_a_date_picker, {
                        value: _ctx.formState.ptzcsj,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formState.ptzcsj = $event)),
                        style: {"width":"220px"},
                        format: "YYYY-MM-DD HH:mm:ss",
                        "show-time": "",
                        placeholder: "请输入时间",
                        onChange: _ctx.onChange,
                        onOk: _ctx.onOk
                      }, null, 8, ["value", "onChange", "onOk"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_a_form_item, { name: "yyzzfjPic" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_a_upload, {
                  "list-type": "picture-card",
                  "file-list": _ctx.frontPhoto,
                  "onUpdate:file-list": _cache[14] || (_cache[14] = ($event: any) => (_ctx.frontPhoto = $event)),
                  action: `${_ctx.url}/admin/common/uploadFile`,
                  headers: {'Authorization': `${ 'Bearer ' + _ctx.location}`},
                  "before-upload": _ctx.beforeUpload,
                  remove: _ctx.RemoveLImg,
                  onChange: _cache[15] || (_cache[15] = (info)=> {
                if (info.file.status === 'uploading') {
                    return;
                }
                if (info.file.status === 'done') {
                    _ctx.formState.yyzzfjPic = info.file.response.data.url;
                    _ctx.formRef = _ctx.$refs.formRef
                    _ctx.formRef.validateFields('yyzzfjPic');
                }
                if (info.file.status === 'error') {
                      _ctx.message.error('上传失败');
                }
                
              }),
                  onPreview: _cache[16] || (_cache[16] = ()=>{_ctx.smrzfjPicBoole=true})
                }, {
                  default: _withId(() => [
                    (_ctx.frontPhoto.length < 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createVNode(_component_plus_outlined),
                          _hoisted_9
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["file-list", "action", "headers", "before-upload", "remove"]),
                _createVNode(_component_a_modal, {
                  visible: _ctx.smrzfjPicBoole,
                  footer: null,
                  onCancel: _cache[17] || (_cache[17] = ()=>{_ctx.smrzfjPicBoole=false})
                }, {
                  default: _withId(() => [
                    _createVNode("img", {
                      alt: "example",
                      style: {"width":"100%"},
                      src: _ctx.formState.yyzzfjPic
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["visible"])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_a_row, { class: "enterRow" }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "发布方（货主）姓名:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    style: {"width":"220px"},
                    value: _ctx.formState.fbfxm,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formState.fbfxm = $event)),
                    placeholder: "请输入（货主）姓名"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "发布方（货主）身份证件号码:",
                class: "aManagementInput",
                name: "fbfsfzjhm"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.fbfsfzjhm,
                    "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formState.fbfsfzjhm = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入身份证件号码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "手机号码:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.yddh,
                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formState.yddh = $event)),
                    style: {"width":"220px"},
                    placeholder: "请输入手机号码"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, {
                label: "国籍（地区）:",
                class: "aManagementInput"
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.formState.gjdq), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_a_button, {
            onClick: _ctx.save,
            class: "aManageQuery",
            type: "primary"
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$router.go(-1))),
            class: "aManageQuery",
            type: "primary"
          }, {
            default: _withId(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
})